module.exports = __webpack_public_path__ + "img/bh_18.3d9483d0.jpg";